export const normalizeURLPathname = (value: string): string | null => {
  if (!value.trim()) {
    return null;
  }

  let path = value;

  try {
    const url = new URL(value);
    path = url.pathname;
  } catch {}

  return path.startsWith('/') ? path : null;
};
